import React from "react"
import DataTable from "@swipesense/data-table"
import { Column } from "react-virtualized"
import Loading from "../Loading"
import PropTypes from "prop-types"
import natsort from "javascript-natural-sort"

const ExcludedAreasTable = props => {
  if (props.loading) return <Loading />

  natsort.insensitive = true
  const data = props.units
    .filter(
      unit => unit.excludeFromCompliance || unit.excludedLocations.length > 0
    )
    .sort((a, b) => natsort(a.name, b.name))

  return (
    <DataTable
      data={data}
      rowHeight={46}
      noRowsMessage="No areas are currently blacklisted. All is in order."
    >
      <Column dataKey="name" width={50} label="Unit" />
      <Column
        dataKey="excludedLocations"
        width={50}
        label="Rooms"
        cellRenderer={({ cellData, rowData }) =>
          rowData.excludeFromCompliance
            ? "Entire unit"
            : cellData
                .map(l => l.name)
                .sort(natsort)
                .join(", ")
        }
      />
    </DataTable>
  )
}

ExcludedAreasTable.propTypes = {
  loading: PropTypes.bool,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      excludeFromCompliance: PropTypes.bool.isRequired,
      excludedLocations: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired
      ).isRequired,
    }).isRequired
  ),
}

export default ExcludedAreasTable
